import React from 'react';
import Alert from 'react-bootstrap/Alert';

class SSUtils extends React.Component {

  static getSupportUs() {
    return (<div className="notification">Like Smart Stake tools? Support us by delegating with Smart Stake.</div>);
  }

}

export default SSUtils;



// WEBPACK FOOTER //
// ./src/util/SSUtils.js